import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ResendCode } from "@faire/retailer-visitor-shared/components/AppSignIn/components/__internal__/ResendCode";
import { ContinueToNextViewButton } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ContinueToNextViewButton";
import { convertErrorToLoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/convertErrorToLoginError";
import { LoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/LoginError";
import { LoginWrapper } from "@faire/retailer-visitor-shared/components/AppSignIn/components/styled";
import { isNumericOrBlank, isNumericOrBlankCode, VALID_CODE_LENGTH } from "@faire/retailer-visitor-shared/components/AppSignIn/components/VerificationInputUtils";
import { View } from "@faire/retailer-visitor-shared/components/AppSignIn/components/View";
import { useSignInEventTracker } from "@faire/retailer-visitor-shared/components/AppSignIn/useSignInEventTracker";
import { VerificationInput } from "@faire/retailer-visitor-shared/components/VerificationInput/VerificationInput";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import login from "@faire/web-api--source/api/v2/users/login/post";
import { trackRetailerPortalLoginModalLoggedInWithCode } from "@faire/web-api--source/events/retailerPortal/actionUnknown/loginModalLoggedInWithCode";
import { trackRetailerPortalLoginModalLoginWithCode } from "@faire/web-api--source/events/retailerPortal/actionUnknown/loginModalLoginWithCode";
import { ILoginRequest } from "@faire/web-api--source/indigofair/data/ILoginRequest";
import { MfaMethod } from "@faire/web-api--source/indigofair/data/MfaMethod";
import React, { useRef, useState } from "react";
export var EnterMFACodeView = function(param) {
    var email = param.email, userToken = param.userToken, onComplete = param.onComplete, onLogin = param.onLogin, mfaTitle = param.mfaTitle, mfaDescription = param.mfaDescription, mfaMethod = param.mfaMethod, password = param.password;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(true), 2), showResend = _useState[0], setShowResend = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isLoadingAutoLogin = _useState1[0], setIsLoadingAutoLogin = _useState1[1];
    var code = useRef("");
    var _useState2 = _sliced_to_array(useState(), 2), error = _useState2[0], setError = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), codeInputError = _useState3[0], setCodeInputError = _useState3[1];
    var _useSSOStore = useSSOStore(), isActive = _useSSOStore.isActive, ssoToken = _useSSOStore.ssoToken;
    var _useState4 = _sliced_to_array(useState(), 2), verificationInputErrorMessage = _useState4[0], setVerificationInputErrorMessage = _useState4[1];
    var trackFieldValue = useSignInEventTracker("ENTER_CODE").trackFieldValue;
    var onContinue = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var user, nextView, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        trackRetailerPortalLoginModalLoginWithCode();
                        setError(undefined);
                        setIsLoadingAutoLogin(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            login(isActive ? ILoginRequest.build({
                                mfa_code: code.current,
                                sso_token: ssoToken,
                                password: password,
                                enable_mfa_method_selection: true
                            }) : ILoginRequest.build({
                                mfa_code: code.current,
                                email_address: email,
                                user_token: !email ? userToken : undefined,
                                password: password,
                                enable_mfa_method_selection: true
                            }))
                        ];
                    case 2:
                        user = _state.sent().user;
                        if (!user) {
                            setError(new LoginError(strictLocalize({
                                id: "6Qgt73",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Invalid credentials"
                                    }
                                ]
                            })));
                            return [
                                2
                            ];
                        }
                        nextView = user.missing_password ? View.CREATE_PASSWORD : View.LOADING;
                        if (nextView === View.LOADING) {
                            trackRetailerPortalLoginModalLoggedInWithCode();
                            onLogin(user);
                        }
                        onComplete({
                            nextView: nextView,
                            loggedInUser: user
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        setCodeInputError(true);
                        setVerificationInputErrorMessage(strictLocalize({
                            id: "RNH93U",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Invalid code, please try again"
                                }
                            ]
                        }));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsLoadingAutoLogin(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onContinue() {
            return _ref.apply(this, arguments);
        };
    }();
    var isValidCode = function() {
        return code.current.length === VALID_CODE_LENGTH && !verificationInputErrorMessage && !codeInputError;
    };
    var handleVerificationCodeInputChange = function(codeValue, slotValue) {
        code.current = codeValue;
        setCodeInputError(false);
        trackFieldValue("verificationCode", codeValue);
        if (!isNumericOrBlankCode(slotValue)) {
            setVerificationInputErrorMessage(strictLocalize({
                id: "Wy3Kfu",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Enter numbers only."
                    }
                ]
            }));
        } else if (isNumericOrBlankCode(code.current)) {
            setVerificationInputErrorMessage(undefined);
            if (isValidCode()) {
                onContinue();
            }
        }
    };
    var onResend = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            login(ILoginRequest.build({
                                email_address: email,
                                user_token: !email ? userToken : undefined,
                                mfa_method: mfaMethod,
                                resend: true
                            }))
                        ];
                    case 1:
                        _state.sent();
                        setShowResend(false);
                        setError(undefined);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        setError(convertErrorToLoginError(e, strictLocalize));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onResend() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(LoginWrapper, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "displaySSerifRegular",
                children: mfaTitle ? mfaTitle : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "k/hsBX",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter code"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: mfaDescription ? mfaDescription : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "cxpBFc",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Copy and paste the code in the email we sent to "
                        },
                        {
                            type: 1,
                            value: "userTextMessageAddress"
                        }
                    ],
                    values: {
                        userTextMessageAddress: email
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(VerificationInput, {
                validateFn: isNumericOrBlank,
                onChange: handleVerificationCodeInputChange,
                errorMessage: verificationInputErrorMessage !== null && verificationInputErrorMessage !== void 0 ? verificationInputErrorMessage : error === null || error === void 0 ? void 0 : error.message,
                errorAll: codeInputError,
                isValidInput: isValidCode(),
                value: code.current,
                ariaLabel: mfaMethod === MfaMethod.SMS ? strictLocalize({
                    id: "dB/6on",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter SMS Code"
                        }
                    ]
                }) : strictLocalize({
                    id: "e4w9ay",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter Email Code"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(ContinueToNextViewButton, {
                onClick: onContinue,
                isLoading: isLoadingAutoLogin,
                disabled: !isValidCode()
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(ResendCode, {
                error: error,
                onResend: onResend,
                showResend: showResend,
                mfaMethod: mfaMethod
            })
        ]
    });
};
